import {MatrixClient, Room} from 'matrix-js-sdk';
import getMetadata from './get-metadata';
import {isNotExcludedRoom} from '@/services/matrix/utils/is-not-excluded-room';

const interestedMemberships = ['join', 'knock', 'invite'];
const interestedMembershipsIgnoringAppVariant = ['knock', 'invite'];
export const getJoinedRooms = (client: MatrixClient): Room[] => {
  return client.getRooms().filter((room) => {
    const myMembership = room.getMyMembership();

    if (!interestedMemberships.includes(myMembership)) {
      return false;
    }

    const metadata = getMetadata(room);
    if (
      !metadata &&
      interestedMembershipsIgnoringAppVariant.includes(myMembership)
    ) {
      return true;
    }
    if (!isNotExcludedRoom(metadata)) {
      return false;
    }
    return true;
  });
};
